import { parseIntOrUndefined } from '../../../../common/lang/numbers';

/**
 * Converts the key from facebook insights into machine readable numbers defining the age range
 *
 * @param key - The key in the format '18-25', '65+' or '-18'
 * @returns - The min and max age values describing this range
 */
export function convertFacebookGenderInsightKeyToValues(
    key: string,
): {
    minAge?: number;
    maxAge?: number;
} {
    /*
     * The below is experimental
     * It handles the cases where facebook decides to return '65+' or '-18'
     * Instead of a valid '18-25' style range.
     * I don't know if they do this but for instagram they return data in this format
     * "M.65+" and they could possibly migrate the facebook api to this in future
     */
    if (key.includes('+')) {
        return {
            minAge: parseIntOrUndefined(key.split('+')[0]),
        };
    } else if (key.includes('-')) {
        const splitByHyphen = key.split('-').filter(splitKey => splitKey !== '');
        if (splitByHyphen.length === 2) {
            return {
                maxAge: parseIntOrUndefined(splitByHyphen[1]),
                minAge: parseIntOrUndefined(splitByHyphen[0]),
            };
        } else {
            return {
                maxAge: parseIntOrUndefined(splitByHyphen[0]),
            };
        }
    }

    return {};
}
